export default __webpack_public_path__ + "2bbaa6c599369fb06ca04ede5319b84f.png";